import React from 'react'
import './Light.css';

const NavbarLight = () => {
    return (
        <div className="navbar-light">
            <h3>React.js To Do List</h3>
            <h6>by <a
                href="https://milostrifunovic1.github.io/portfolio/"
                target="_blank"
                rel="noopener noreferrer">
                Miloš Trifunović</a></h6>
        </div>
    )
}

export default NavbarLight;
